import { useMemo } from "react";
import { type Control, useWatch } from "react-hook-form";
import { useCustomFormContext } from "@/components/site-builder/modules/CustomFormModule/context/customFormContext";
import { useCustomFormFieldProps } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormFieldProps";
import { getFormFields } from "@/components/site-builder/modules/CustomFormModule/utils/getFormFields";
import { FormBuilderFieldCode } from "@/constants/form-builder";
import type { FormBuilderFormField } from "@/types/form-builder";

export function useCustomFormStateOfResidenceOptions(control?: Control) {
  const { formEntity } = useCustomFormContext();
  const { regions } = formEntity.meta;
  const countryField = useMemo(() => {
    return getFormFields(formEntity).find(
      (field) => field.code === FormBuilderFieldCode.CountryOfResidence,
    );
  }, [formEntity]);
  const { fieldName: countryFieldName } = useCustomFormFieldProps(
    countryField as FormBuilderFormField,
  );
  const selectedCountry = useWatch({ name: countryFieldName, control });

  return useMemo(() => {
    const region = regions.find((region) => region.id === selectedCountry);
    if (!region) return [];

    return (region.options || []).map((option) => ({
      ...option,
      selectable: true,
    }));
  }, [selectedCountry, regions]);
}
